var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 30,
    viewBox: "0 0 27 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7833 7.5C17.7833 6.2568 17.2902 5.06451 16.4126 4.18544C15.5349 3.30636 14.3446 2.8125 13.1034 2.8125C11.8623 2.8125 10.672 3.30636 9.79433 4.18544C8.91669 5.06451 8.42365 6.2568 8.42365 7.5C8.42365 8.7432 8.91669 9.93549 9.79433 10.8146C10.672 11.6936 11.8623 12.1875 13.1034 12.1875C14.3446 12.1875 15.5349 11.6936 16.4126 10.8146C17.2902 9.93549 17.7833 8.7432 17.7833 7.5ZM5.61576 7.5C5.61576 5.51088 6.40464 3.60322 7.80886 2.1967C9.21307 0.790176 11.1176 0 13.1034 0C15.0893 0 16.9938 0.790176 18.398 2.1967C19.8023 3.60322 20.5911 5.51088 20.5911 7.5C20.5911 9.48912 19.8023 11.3968 18.398 12.8033C16.9938 14.2098 15.0893 15 13.1034 15C11.1176 15 9.21307 14.2098 7.80886 12.8033C6.40464 11.3968 5.61576 9.48912 5.61576 7.5ZM2.88393 27.1875H23.323C22.8023 23.4785 19.6201 20.625 15.7768 20.625H10.4301C6.58682 20.625 3.40456 23.4785 2.88393 27.1875ZM0 28.2598C0 22.4883 4.6681 17.8125 10.4301 17.8125H15.7768C21.5388 17.8125 26.2069 22.4883 26.2069 28.2598C26.2069 29.2207 25.4289 30 24.4695 30H1.73738C0.778017 30 0 29.2207 0 28.2598Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserWhite);
export default __webpack_public_path__ + "static/media/User White.803baa32d47b03e0a8e2422897617b34.svg";
export { ForwardRef as ReactComponent };